import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { Provider } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';

import './index.scss';
import App from './App';
// import { UserProvider } from './contexts/user.context';
// import { CategoriesProvider } from './contexts/cattegories.context';

import { store, persistor } from './store/store';

import reportWebVitals from './reportWebVitals';
import { stripePromise } from './utils/stripe/stripe.utils';
// import { CartProvider } from './contexts/cart.context';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
       
    <BrowserRouter>
    <Elements stripe={stripePromise}>
    {/* <UserProvider> */}
      
        {/* <CartProvider> */}
        <App />
        {/* </CartProvider> */}
       
      
    {/* </UserProvider> */}
    </Elements>
    </BrowserRouter>
   
    </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
